import type { FC } from "react";

import type { ITrafficShareBarProps } from "../../../styled components/StyledTrafficShare/src/StyledTrafficShare";
import {
    TrafficShareBar,
    TrafficShareBarThin,
    TrafficShareContainer,
} from "../../../styled components/StyledTrafficShare/src/StyledTrafficShare";

interface ITrafficShareProps {
    data: ITrafficShareBarProps[];
    minWidthToShowData?: number;
    minWidthToShowDataMiddle?: number;
    className?: string;
    barGap?: number;
    height?: number;
}

export const TrafficShare: FC<ITrafficShareProps> = ({
    data,
    minWidthToShowData,
    minWidthToShowDataMiddle = 0.1,
    className,
    barGap,
    height,
}) => {
    const filteredZeroWidth = data.filter((item) => Number(item.width) > 0);
    return (
        <TrafficShareContainer
            className={className}
            height={height}
        >
            {filteredZeroWidth.map((item, index) => {
                if (index === 0 || index === filteredZeroWidth.length - 1) {
                    const showData = minWidthToShowData
                        ? Number(item.width) > minWidthToShowData
                        : Number(item.width) > 0.1;
                    return (
                        <TrafficShareBar
                            style={{}}
                            marginRight={barGap}
                            name={item.name}
                            key={index}
                            color={item.color}
                            backgroundColor={item.backgroundColor}
                            width={item.width}
                        >
                            {showData ? item.text : ""}
                        </TrafficShareBar>
                    );
                }
                // Added due to major performance issue in loyalty page where we render 100 cells of the top component causing slow machines to struggle adding multiple css rules to dom
                return (
                    <TrafficShareBarThin
                        key={index}
                        style={{
                            color: item.color,
                            backgroundColor: item.backgroundColor,
                            width: `${Number(item.width) * 100}%`,
                            marginRight: `${barGap}px`,
                        }}
                    >
                        {Number(item.width) > minWidthToShowDataMiddle ? item.text : ""}
                    </TrafficShareBarThin>
                );
            })}
        </TrafficShareContainer>
    );
};
